function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = [
  'prefixCls',
  'fields',
  'initialValues',
  'onSearch',
  'shouldTriggerSearchOnReset',
  'customComponents',
  'open',
  'onOpenPropsChange',
];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _iterableToArray(iter) {
  if (
    (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) ||
    iter['@@iterator'] != null
  )
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useEffect, useImperativeHandle, useMemo, useState, useCallback } from 'react';
import { Button, FormBuilder, Icon, Space } from 'udesk-ui';
import { usePrefixCls } from '../utils';
import { FilterContainer } from './components/FilterContainer';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import './style/index';
var ACTION_BUTTONS_NAME = '__actionButtons';
// transform: rotate(-180deg);
var Buttons = function Buttons(props) {
  var formInstance = props.formInstance,
    open = props.open,
    onOpenStatusChange = props.onOpenStatusChange,
    showMore = props.showMore,
    onReset = props.onReset;
  var _useLocaleReceiver = useLocaleReceiver('CommonFilter'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    contextLocale = _useLocaleReceiver2[0];
  return /*#__PURE__*/ React.createElement(
    Space,
    null,
    showMore &&
      /*#__PURE__*/ React.createElement(
        Button,
        {
          type: 'link',
          onClick: function onClick() {
            return onOpenStatusChange(!open);
          },
          style: {
            paddingLeft: 0,
            paddingRight: 0,
          },
          icon: /*#__PURE__*/ React.createElement(Icon, {
            type: open ? 'UpOutlined' : 'DownOutlined',
            antdIcon: true,
          }),
        },
        open ? contextLocale.lang.collapse : contextLocale.lang.expand,
      ),
    /*#__PURE__*/ React.createElement(
      Button,
      {
        onClick: function onClick() {
          formInstance === null || formInstance === void 0 ? void 0 : formInstance.resetFields();
          Promise.resolve().then(function () {
            onReset();
          });
        },
      },
      contextLocale.lang.reset,
    ),
    /*#__PURE__*/ React.createElement(
      Button,
      {
        type: 'primary',
        htmlType: 'submit',
      },
      contextLocale.lang.search,
    ),
  );
};
var CommonFilter = /*#__PURE__*/ React.forwardRef(function (props, ref) {
  var customizePrefixCls = props.prefixCls,
    fields = props.fields,
    initialValues = props.initialValues,
    onSearch = props.onSearch,
    shouldTriggerSearchOnReset = props.shouldTriggerSearchOnReset,
    customComponents = props.customComponents,
    open = props.open,
    onOpenPropsChange = props.onOpenPropsChange,
    args = _objectWithoutProperties(props, _excluded);
  var _usePrefixCls = usePrefixCls('common-filter', customizePrefixCls),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 2),
    pageContainerPrefixCls = _usePrefixCls2[0],
    prefixCls = _usePrefixCls2[1];
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    _open = _useState2[0],
    _setOpen = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    needRerender = _useState4[0],
    _forceUpdate = _useState4[1];
  var forceUpdate = function forceUpdate() {
    _forceUpdate(Math.random());
  };
  useEffect(
    function () {
      typeof open === 'boolean' && _setOpen(open);
    },
    [open],
  );
  var _FormBuilder$useForm = FormBuilder.useForm(),
    _FormBuilder$useForm2 = _slicedToArray(_FormBuilder$useForm, 1),
    formInstance = _FormBuilder$useForm2[0];
  useImperativeHandle(ref, function () {
    return {
      closeFilter: function closeFilter() {
        return _setOpen(false);
      },
      openFilter: function openFilter() {
        return _setOpen(true);
      },
      formInstance: formInstance,
    };
  });
  var onReset = useCallback(
    function () {
      shouldTriggerSearchOnReset &&
        (onSearch === null || onSearch === void 0 ? void 0 : onSearch(initialValues));
    },
    [onSearch, initialValues, shouldTriggerSearchOnReset],
  );
  var config = useMemo(
    function () {
      var showMore = shouldShowMoreBtnDisplaced(fields);
      var finalFields = [].concat(_toConsumableArray(fields), [
        {
          type: 'Buttons',
          name: ACTION_BUTTONS_NAME,
          props: {
            formInstance: formInstance,
            open: _open,
            onOpenStatusChange: _setOpen,
            showMore: showMore,
            onReset: onReset,
          },
          isDefault: true,
        },
      ]);
      return {
        fields: showMore
          ? finalFields.map(function (i) {
              return _objectSpread(
                _objectSpread({}, i),
                {},
                {
                  forceHidden:
                    !_open &&
                    !i.isDefault &&
                    (formInstance.getFieldValue(i.name) === undefined ||
                      formInstance.getFieldValue(i.name) === ''),
                },
              );
            })
          : finalFields,
        layout: 'inline',
        footerRender: false,
        customComponents: Object.assign(
          {
            Buttons: Buttons,
          },
          customComponents,
        ),
        initialValues: _objectSpread(
          _objectSpread({}, initialValues),
          {},
          {
            __actionButtons: true,
          },
        ),
      };
    },
    [
      fields,
      initialValues,
      shouldTriggerSearchOnReset,
      customComponents,
      _open,
      needRerender,
      onReset,
    ],
  );
  var onFinish = useCallback(
    function (value) {
      var ret = Object.keys(value).reduce(function (prev, key) {
        if (key !== ACTION_BUTTONS_NAME && value[key] !== undefined) {
          prev[key] = value[key];
        }
        return prev;
      }, {});
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(ret);
      forceUpdate();
    },
    [onSearch],
  );
  return /*#__PURE__*/ React.createElement(
    FilterContainer,
    {
      prefixCls: prefixCls,
      className: pageContainerPrefixCls,
    },
    /*#__PURE__*/ React.createElement(
      FormBuilder,
      _objectSpread(
        _objectSpread({}, config),
        {},
        {
          onFinish: onFinish,
          form: formInstance,
        },
      ),
    ),
  );
});
CommonFilter.defaultProps = {
  shouldTriggerSearchOnReset: true,
  open: false,
};
export default /*#__PURE__*/ React.memo(CommonFilter);
function shouldShowMoreBtnDisplaced(fields) {
  return (
    Boolean(fields.length) &&
    fields.some(function (i) {
      return i.isDefault;
    }) &&
    fields.some(function (i) {
      return !i.isDefault;
    })
  );
}
